import React from 'react';
import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { addInlineComment, ToolTipContent } from '@atlaskit/editor-common/keymaps';
import { currentMediaNodeWithPos } from '@atlaskit/editor-common/media-single';
import { annotationMessages } from '@atlaskit/editor-common/messages';
import { calculateToolbarPositionAboveSelection, calculateToolbarPositionTrackHead } from '@atlaskit/editor-common/utils';
import CommentIcon from '@atlaskit/icon/glyph/comment';
import { setInlineCommentDraftState } from './commands';
import { AnnotationSelectionType, AnnotationTestIds } from './types';
import { isSelectionValid } from './utils';
export var buildToolbar = function buildToolbar(editorAnalyticsAPI) {
  return function (state, intl) {
    var isToolbarAbove = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isCommentOnMediaOn = arguments.length > 3 ? arguments[3] : undefined;
    var _supportedNodes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var schema = state.schema;
    var selectionValid = isSelectionValid(state, isCommentOnMediaOn);
    var isMediaSelected = isCommentOnMediaOn && currentMediaNodeWithPos(state);

    // comments on media can only be added via media floating toolbar
    if (isMediaSelected || selectionValid === AnnotationSelectionType.INVALID) {
      return undefined;
    }
    var createCommentMessage = intl.formatMessage(annotationMessages.createComment);
    var commentDisabledMessage = intl.formatMessage(annotationMessages.createCommentInvalid);
    var createComment = {
      type: 'button',
      showTitle: true,
      disabled: selectionValid === AnnotationSelectionType.DISABLED,
      testId: AnnotationTestIds.floatingToolbarCreateButton,
      icon: CommentIcon,
      tooltipContent: selectionValid === AnnotationSelectionType.DISABLED ? commentDisabledMessage : /*#__PURE__*/React.createElement(ToolTipContent, {
        description: createCommentMessage,
        keymap: addInlineComment
      }),
      title: createCommentMessage,
      onClick: function onClick(state, dispatch) {
        if (editorAnalyticsAPI) {
          editorAnalyticsAPI.fireAnalyticsEvent({
            action: ACTION.CLICKED,
            actionSubject: ACTION_SUBJECT.BUTTON,
            actionSubjectId: ACTION_SUBJECT_ID.CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
            eventType: EVENT_TYPE.UI,
            attributes: {
              source: 'highlightActionsMenu',
              // @ts-expect-error - Object literal may only specify known properties, and 'pageMode' does not exist in type
              // This error was introduced after upgrading to TypeScript 5
              pageMode: 'edit'
            }
          });
        }
        return setInlineCommentDraftState(editorAnalyticsAPI)(true)(state, dispatch);
      },
      supportsViewMode: true // TODO: MODES-3950 Clean up this floating toolbar view mode logic
    };
    var annotation = schema.marks.annotation;
    var validNodes = Object.keys(schema.nodes).reduce(function (acc, current) {
      var type = schema.nodes[current];
      if (type.allowsMarkType(annotation)) {
        acc.push(type);
      }
      return acc;
    }, []);
    var toolbarTitle = intl.formatMessage(annotationMessages.toolbar);
    var calcToolbarPosition = isToolbarAbove ? calculateToolbarPositionAboveSelection : calculateToolbarPositionTrackHead;
    var onPositionCalculated = calcToolbarPosition(toolbarTitle);
    return {
      title: toolbarTitle,
      nodeType: validNodes,
      items: [createComment],
      onPositionCalculated: onPositionCalculated
    };
  };
};